import xingyeLogo from './xingye-logo.svg';
import talkieLogo from './talkie-logo.svg';
import { isTalkie } from '../../utils';

export const logoIcon = isTalkie ? talkieLogo : xingyeLogo;
